/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import axios, { AxiosInstance } from "axios";
import _ from "lodash";
import { VApplication } from "../application/index";
import { DeviceInfoService } from "./device-info.service";
import { NO_IMAGE, THUMB_NAIL } from "../assets/images";
import { provMapProps } from "../pages/ProvenanceStepDetailView/config/default-blueprint.json";
import { camelCase } from "change-case";
import stepDetails from "./config/step-detal.json";

const SERVICE_NAME = "product-provenance-rest.service";
const { LoggerModule } = require("@vlinder-web/logger-module-react");
const log: any = LoggerModule.getInstance();

const is = require("is_js");

interface IProps {
    baseURL: string;
    timeout?: number;
    headers?: any;
}

const getDeviceInfoService = () => {
    const app = VApplication.getInstance();
    return app?.getSync("services.DeviceInfoService") as DeviceInfoService;
};

export class ProductProvenanceStepRestService {
    name = SERVICE_NAME;
    private static instance: ProductProvenanceStepRestService;

    private api: AxiosInstance;

    private constructor(props: IProps | any) {
        const deviceInfoService = getDeviceInfoService();
        this.api = axios.create({
            baseURL: props.baseURL,
            timeout: props.timeout ?? 30000, // 30 secs
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                ...{ ...deviceInfoService.getDeviceInfo() },
                ...{ ...deviceInfoService.getAppInfo() },
                ...{ ...(props.headers || {}) },
            },
        });
        this.report();
    }

    static getInstance(props: IProps | any = {}) {
        if (!this.instance) {
            this.instance = new ProductProvenanceStepRestService(props);
        }
        return this.instance;
    }
    async init() {}

    _provenanceStepData = (data: any) => {
        let _provenance: any = {};

        const _getMeta = (metaData: any) => {
            let _meta: any[] = [];
            metaData &&
                Array.isArray(metaData) &&
                metaData.length > 0 &&
                metaData.map((item: any, index: number) => {
                    console.log(`camelCase(item?.label) :`, camelCase(item?.label))
                    if (camelCase(item?.label) !== "credentialLogo") {
                        _meta.push({
                            key: item?.label,
                            value: item?.value,
                        });
                    }
                });
            return _meta;
        };

        return {
            //idx: _data?.credTxId,
            title: data?.ProvDetailInfo?.title,
            subtitle: data?.ProvStepTitle?.title,
            //serialNo: 'Rare #/1',
            // img: "https://dev-dc.vlinder.io/imgsrv/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // // tag: 'DIAMOND',
            // // productCategory: 'collectibles',
            // // category: 'diamond',
            // price: [
            //     {
            //         type: "fiat",
            //         currency: "USD",
            //         locale: "en-US",
            //         amount: 1500.0,
            //     },
            //     {
            //         type: "crypto",
            //         currency: "ETH",
            //         amount: 0.5,
            //     },
            // ],
            // createdBy: {
            //     userName: "SWISS TIMING",
            //     userId: "swiss-timing",
            //     link: "/swiss-timing",
            //     authProofUrl:
            //         "https://gateway.pinata.cloud/ipfs/QmTJFM4QPeN5aYc7uDZrHNdsA8oXQrn58fspRNNV3PmSYp",
            // },
            meta: _getMeta(data?.ProvDetailInfo?.provInfoList),
            // // actions: [
            // //     {
            // //         key: "buyNowFiat",
            // //         title: "Buy in USD"
            // //     },
            // //     {
            // //         key: "buyNowCrypto",
            // //         title: " Buy in ETH"
            // //     }
            // // ],
            images: [
                {
                    original: NO_IMAGE,
                    thumbnail: NO_IMAGE,
                    thumbnailHeight: "70",
                    thumbnailClass: "image-thumb",
                },
            ],
        };
    };

    _getImage(images: any[]) {
        let resultImg: any[] = [];
        images &&
            Array.isArray(images) &&
            images.forEach((item: any, index: number) => {
                if (item) {
                    if(item?.type === "video") {
                        resultImg.push({
                            original: THUMB_NAIL,
                            thumbnail: THUMB_NAIL,
                            thumbnailHeight: "100",
                            thumbnailClass: "image-thumb",
                            type: "video",
                            embedUrl: item?.video,
                        });
                    } else {
                    resultImg.push({
                        original: item?.image,
                        thumbnail: item?.image,
                        thumbnailHeight: "100",
                        thumbnailClass: "image-thumb",
                        type: "image",
                    });
                }
                }
            });
        return resultImg;
    }

    _getMarkers(geoJson: any) {
        if (geoJson) {
            let markers: any = [];
            geoJson?.features &&
                Array.isArray(geoJson?.features) &&
                geoJson?.features.length > 0 &&
                geoJson?.features.forEach((item: any, index: number) => {
                    if (item?.geometry?.type === "Point") {
                        item?.geometry?.coordinates &&
                            Array.isArray(item?.geometry?.coordinates) &&
                            item?.geometry?.coordinates.length > 0 &&
                            markers.push({
                                lat: item?.geometry?.coordinates[1],
                                lng: item?.geometry?.coordinates[0],
                            });
                    }
                });
            console.log(`geoJson in service:`, markers);
            return markers;
        }
    }

    _getDefaultCenter(geoJson: any) {
        if (geoJson) {
            let coordinates: any[] =
                geoJson?.features &&
                Array.isArray(geoJson?.features) &&
                geoJson?.features.length > 0
                    ? geoJson?.features[0]?.geometry?.coordinates
                    : [];
            if (coordinates && coordinates.length > 0) {
                let defaultCenter = {
                    lat: coordinates[1],
                    lng: coordinates[0],
                };

                console.log(`defaultCenter in service:`, defaultCenter);
                return defaultCenter;
            }
        }
    }

    async provenanceStepDetailView(payload: any) {
        log.blue(SERVICE_NAME, ":", payload);
        try {
            // const res = await this.api.post("/provenance/step_cred/no_auth/", {
            //     gtin: payload?.gtinKey,
            //     credTxId: payload?.credTxId,
            // });
            let _id = payload?.id && parseInt(payload?.id);
            if (stepDetails?.provenances) {
                let _data = _.find(stepDetails?.provenances, { id: _id });
                log.blue(` on find data :`, _data)
                if (_data) {
                    return {
                        ..._data,
                        //provenanceData: this._provenanceStepData(_data),
                        CHIP_LIST: _data?.ChipList,
                        PROV_DETAIL_INFO: _data?.ProvDetailInfo,
                        PROV_STEP_TITLE: _data?.ProvDetailInfo,
                        PROV_STEP_TITLE_CARD: _data?.ProvStepTitleCard,
                        PROV_STEP_GEOJSON: this._getMarkers(
                            _data?.provMapProps?.geojson
                        ),
                        defaultCenter: this._getDefaultCenter(
                            _data?.provMapProps?.geojson
                        ),
                        defaultZoom: _data?.provMapProps?.defaultZoom,
                        PROV_STEP_IMAGES: this._getImage(
                            _data?.ProvStepImages?.provImages
                        ),
                    };
                }
                // return {

                // }
            }
            // let _data =  {CHIP_LIST,PROV_DETAIL_INFO,PROV_STEP_TITLE,PROV_STEP_TITLE_CARD }
            // return _data;
        } catch (err) {}
    }

    private report() {
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
        log?.info(SERVICE_NAME, "Module Report");
        log?.info(SERVICE_NAME, "⦿ Name: " + this.name);
        log?.info(SERVICE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
